import React, { useState, useRef, useEffect } from 'react';
import GridItem from "@insite/mobius/GridItem";
import translate from "@insite/client-framework/Translate";
import Clickable from "@insite/mobius/Clickable";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Img from "@insite/mobius/Img";
import { css } from "styled-components";
import { IconWrapper } from "@insite/mobius/Icon";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Button, { ButtonIcon } from "@insite/mobius/Button";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import RewardsTooltipIcon from "@NA/Icons/RewardsTooltipIcon";

export interface LoyaltyToolTip {  
    GridItem?: InjectableCss; 
    tooltipIcon?: InjectableCss;
    tooltipHeading?: InjectableCss;
    tooltipSubheading?: InjectableCss;
    tooltipRow?: InjectableCss;
    tooltipNote?: InjectableCss;
    tooltipPopup?: InjectableCss;
    tooltipinnerTable?: InjectableCss;
    tooltipTable?: InjectableCss;
    tooltipleftRow?: InjectableCss;
    tooltiprightRow?: InjectableCss;
    tooltipContent?: InjectableCss;
    tootipParent?: InjectableCss;
}

const loyaltyRewards: LoyaltyToolTip = {
    GridItem: {
        css: css`
        display: block;
        width: 100%;

        &.tooltipContent {
            font-size: 12px;
            font-weight: normal;
            color: #2d2926;
            width: 384px;
            max-width: 384px;
            height: auto;
            padding: 14px 34px 10px 24px;
            background-color: #fff;
            border: 1px solid #bbb;
            border-radius: 4px;
            position: absolute;
            right:calc(50% - 192px) !important;
            cursor: default;
            top: auto;
            bottom: 35px;

            ${({ theme }) => {
                return breakpointMediaQueries(
                    theme,
                    [
                        css`
                        display: block;
                        width: max-content;
                        max-width: 350px;
                        left: -11px;
                        height: auto;
                        max-height: max-content;
                      
                        margin: 0 auto;
                        transform: translate(-80%,0);
                        `,
                        css`
                        display: block;
                        width: max-content;
                        max-width: 350px;
                        left: -11px;
                        height: auto;
                        max-height: max-content;
                      
                        margin: 0 auto;
                        transform: translate(-80%,0);
                        `,
                    ],
                    "max",
                );
            }}

                &:after {
                    content: "";
                    position: absolute;
                    left: calc(50% - 15px);
                    bottom: -8px;
                    border: 8px solid #fff;
                    box-shadow: -1px 1px 0 0 #bbb;
                    border-color: transparent transparent #fff #fff;
                    transform: rotate(315deg);
                    ${({ theme }) => {
                        return breakpointMediaQueries(
                            theme,
                            [
                                css`
                                left: 79.0%;
                                `,
                                css`
                                    left: 79.0%;
                                `,
                            ],
                            "max",
                        );
                    }}
                }
                .tooltipTable {    
                    color: #2d2926;
                    font-size: 14px;
                    font-weight: 400;
                    margin-bottom: 18px;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                    display: table-cell;
                    padding: 0;
                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            font-size: 12px;
                        `,
                        css`
                            font-size: 12px;
                        `,
                        css`width:95%`,
                        css`width:95%`,
                        css``,
                    ])}
                },
                > ${IconWrapper} {
                    color: #006ae3;
                    position: absolute;
                    right: 10px;
                    > svg {
                        stroke-width: 1.5;
                        cursor: pointer;
                    },
                }
                
            },
        `,
    },
    tooltipIcon: {
        css: css`
            display: flex;
            justify-content: center;
            position: relative;
            button {
                margin-left: 6px;
               &:focus{
                outline:0;
               }
            }
        `,
    },
    tootipParent: {
        css: css`
        position:relative;
        `,
    },
    tooltipHeading: {
        css: css`
            font-size: 15px;
            font-weight: 700;
            color: #2d2926;
            line-height: 26px;
            display: block;
            text-align: left;
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    font-size: 14px;
                `,
                css`
                    font-size: 14px;
                `,
                css``,
                css``,
                css``,
            ])}
        `,
    },
    tooltipSubheading: {
        css: css`
            color: #2d2926;
            font-size: 14px;
            font-weight: 400;
            line-height: 18px;
            margin-bottom: 10px;
            float: left;
            text-align: left;
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    font-size: 12px;
                    float: left;
                    margin-left: 0px;
                `,
                css`
                    font-size: 12px;
                    float:none;
                    margin-left:-26px;
                `,
                css``,
                css``,
                css``,
            ])}
        `,
    },

    tooltipRow: {
        css: css`
            height: auto;
            min-height: 30px;
            align-items: center;
            display: flex;
            border-bottom: 1px solid #ddd;
            padding: 0 10px;
            position: relative;
            text-align: left;

            &::after {
                content: "";
                position: absolute;
                border-right: 1px solid #ddd;
                right: calc(35% + 10px);
                top: 0;
                height: 100%;
            }
            &:first-child {
               // padding: 5.5px 10px 5.5px 10px;
               line-height: 23px;
            }
            &:first-child::after {
                display: none;
            }
            &:last-child {
                border-bottom: none;
            }
        `,
    },
    tooltipleftRow: {
        css: css`
            width: 65%;
            padding: 5.5px 0;
            display: inline-block;
            line-height: normal;
        `,
    },
    tooltiprightRow: {
        css: css`
            padding: 5.5px 0 5.5px 0;
            margin-left: 13px;
            width: 35%;
            line-height: normal;
        `,
    },
    tooltipNote: {
        css: css`
            color: #2d2926;
            font-size: 12px;
            font-weight: 400;
            line-height: 17px;
            margin-bottom: 8px;
            margin-top: 18px;
            position: relative;
            float: left;
            text-align: left;
        `,
    },
};

const TooltipComponent = () => {
    const [tooltipVisible, setTooltipVisible] = useState<boolean>();
    const tooltipRef = useRef<HTMLDivElement>(null);
    const [tooltipHeight, setTooltipHeight] = useState(0);

    const openTooltip = () => {
        setTooltipVisible(true);
    };
    const closeTooltip = () => {
        setTooltipVisible(false)
    }

    useEffect(() => {
        if (tooltipRef.current) {
          const height = tooltipRef.current.offsetHeight;
          setTooltipHeight(height);
          const headerElement  = document.querySelector("header")!.scrollHeight;
          const elementToolTip = tooltipRef.current!.parentElement!.parentElement!.getBoundingClientRect().top;
          if (elementToolTip <= height + headerElement) {
                const scrollPo = window.scrollY - height;
                window.scroll({
                    top:scrollPo,
                    behavior: 'smooth'
                })
            } else {
                window.scrollTo(0, window.scrollY);
            }
        }
      }, [tooltipVisible]);
    
    const styles = loyaltyRewards;
  
  return (
    <>
    <Typography {...styles.tooltipIcon}>
        {translate("Bonus Category Spend")}
        <Clickable onClick={openTooltip}>
            <RewardsTooltipIcon />
        </Clickable>
        <StyledWrapper {...styles.tootipParent}>
        {tooltipVisible && 
            <StyledWrapper ref={tooltipRef} {...styles.GridItem} className="tooltipContent">
                <ButtonIcon src="X" onClick={closeTooltip}/>
                <Typography {...styles.tooltipHeading}> {translate("Bonus Category Spend")} </Typography>
                <Typography {...styles.tooltipSubheading}>  
                {translate("Earn up to")} 
                <strong> {translate("2 Extra Points")} </strong>
                {translate("for Every Dollar Spent at ADI*")} 
                </Typography>
                    <GridItem {...styles.GridItem} className="tooltipTable">
                        {/* <Typography {...styles.tooltipRow}> {translate("1 Point for Every Dollar Spent at ADI")} </Typography> */}
                    
                        <Typography {...styles.tooltipRow}>
                            <Typography {...styles.tooltipleftRow}> {translate("Online or ADI App")} </Typography>
                            <Typography {...styles.tooltiprightRow}> {translate("1 Extra Point")} </Typography>
                        </Typography>
                
                        <Typography {...styles.tooltipRow}>
                            <Typography {...styles.tooltipleftRow}> {translate("ADI Exclusive Brands")} </Typography>
                            <Typography {...styles.tooltiprightRow}> {translate("1 Extra Point")} </Typography>
                        </Typography>
                    
                        <Typography {...styles.tooltipRow}>
                            <Typography {...styles.tooltipleftRow}> {translate("Featured Suppliers")} </Typography>
                            <Typography {...styles.tooltiprightRow}> {translate("1 Extra Point")} </Typography>
                        </Typography>
                
                    </GridItem>
                    <Typography {...styles.tooltipNote}> 
                     {translate("*Earn three points when ADI Exclusive brands or Featured Suppliers are")}
                     <strong> {translate("purchased online")} </strong>
                     {translate("or through the ADI App.")}                     
                     </Typography>
            </StyledWrapper>}
        </StyledWrapper>
    </Typography>
    </>
  );
};


export default TooltipComponent;